/*
 * change to https://next.material-ui.com/api/loading-button/ after it release
 */

import { Button, ButtonProps, CircularProgress } from '@mui/material'

export type LoadingButtonProps = ButtonProps & { pending?: boolean }

const LoadingButton = ({ children, color, pending, ...props }: LoadingButtonProps) => (
  <Button
    {...props}
    disabled={pending || props.disabled}
    color={color}
    endIcon={pending && <CircularProgress size="1em" color={color} />}
  >
    {children}
  </Button>
)

export default LoadingButton
